import { loadView } from '@/router'
import invoices from './invoices'
import reconciliation from './reconciliation'
import credits from './credits'
import carrier from './carrier'
import generateInvoices from './generateInvoices'

export default [
  {
    path: 'billing',
    name: 'billing',
    component: loadView('Application/Billing'),
    redirect: {
      name: 'billing-dashboard'
    },
    children: [
      {
        path: 'dashboard',
        name: 'billing-dashboard',
        component: loadView('Application/Billing/Dashboard')
      },
      ...invoices,
      ...reconciliation,
      ...credits,
      ...carrier,
      ...generateInvoices

    ]
  }
]
